export { default } from "./FormLabel.js";
export * from "./FormLabel.js";
export { default as formLabelClasses } from "./formLabelClasses.js";
export * from "./formLabelClasses.js";